export default __webpack_public_path__ + "static/media/alfaomega.e3fbfcce.png";